import React from 'react';
import { useNavigate } from 'react-router-dom';

const Privacy = () => {
    const navigate = useNavigate();

    return (
        <div className="max-w-xl mx-auto px-4 py-10 text-sm text-gray-700 leading-relaxed">
            <h1 className="text-lg font-semibold mb-4">Privacy & Terms</h1>
            <p className="mb-6">
                Express stores the messages you create to display on the Wall of Emotions.
                These may include names or messages you voluntarily enter. No login is required,
                and we do not collect email addresses or track you across sessions.
                All shared messages are public. By using this app, you agree to express and share respectfully.
            </p>

            <button
                onClick={() => navigate('/')}
                className="text-sm text-blue-600 underline hover:text-blue-800 transition"
            >
                ← Back to Home
            </button>
        </div>
    );
};

export default Privacy;
